<template>
  <div class="app-container-v2 table-container-v2 has-tabs" v-loading="loading">
    <div class="title-box">
      <div class="title-left">
        <div class="select-v2">
          <el-input class="query-select" v-model="queryParams.batchId" :placeholder="$t('batchIds')"
                    style="width: 230px;"
          ></el-input>
        </div>
        <div>
          <el-date-picker
            style="width: 150px;margin-right: 15px;"
            v-model="queryParams.queryDate"
            type="month"
            format="yyyy-MM"
            value-format="yyyy-MM"
            :placeholder="$t('queryDate')">
          </el-date-picker>
        </div>
        <div class="select-v2">
          <el-select class="query-select" v-model="queryParams.cusid" collapse-tags :placeholder="$t('queryCompany')"
                     filterable clearable style="width: 230px;">
            <el-option v-for="item in companyCode" :key="item.cusid" :value="item.cusid" :label="item.cusname"/>
          </el-select>
        </div>
      </div>
      <div class="title-right">
        <el-button type="primary" class="button-v2" @click="search">{{ $t('query') }}</el-button>
        <el-button type="primary" class="button-v2" @click="download">{{ $t('export') }}</el-button>
        <el-button type="primary" class="button-v2" @click="downloadSource">{{ $t('export') }} Source</el-button>
<!--        <el-button type="primary" class="button-v2" @click="sendEmail">{{ $t('sendEmail') }}</el-button>-->
      </div>
    </div>
    <div class="table-body">
      <div class="table-body-tabs-content flex vertical jbetween">
        <div class="table-body-table">
          <air-table
            ref="airTable"
            class="table-v2"
            :show-operation="false"
            align="center"
            :columns="columns"
            :data="tableData"
            :min-width="160"
            @checkbox-change="handleSelectionChange"
            @checkbox-all="handleSelectionChange"
            @change-filter="changeFilter"
          ></air-table>
        </div>
<!--        <bsp-pagination :pager-config.sync="pagerConfig" @page-change="list" @page-size-change="pageSizeChange"-->
<!--                        show-page-size></bsp-pagination>-->
      </div>
    </div>
    <air-confirm-v2
      :show.sync="confirmShow"
      :title="confirmTitle"
      :content="confirmContent"
      :confirm-function="confirmFunction"
    ></air-confirm-v2>
  </div>
</template>

<script>
  import {down, list, selectCus} from "@/api/tesla/teslafinancialStatements.js";

  export default {
    data() {
      return {
        queryParams: {},
        columns: [
          {title: 'JournalLegalEntity', field: 'JournalLegalEntity', minWidth: 160},
          {title: 'Transaction Date', field: 'TransactionDate', minWidth: 160},
          {title: 'JournalBatchNumber', field: 'JournalBatchNumber', minWidth: 160},
          {title: 'LineNumber', field: 'LineNumber'},
          {title: 'Company', field: 'Company'},
          {title: 'Account Type', field: 'AccountType'},
          {title: 'AccountDisplayValue', field: 'AccountDisplayValue', minWidth: 160},
          {title: 'CurrencyCode', field: 'CurrencyCode'},
          {title: 'Debit', field: 'Debit'},
          {title: 'Credit', field: 'Credit'},
          {title: 'Text', field: 'Text'},
          {title: 'JournalName', field: 'JournalName'},
          {title: 'Voucher', field: 'Voucher'},
          {title: 'jsReservationNumber', field: 'jsReservationNumber', minWidth: 160},
          {title: 'TSLADebtTransactionType', field: 'TSLADebtTransactionType', minWidth: 160}
        ],
        tableData: [],
        companyCode: [],
      };
    },
    methods: {
      init() {
        const params = {
          cusName: '',
        };
        selectCus(params).then(res => {
          this.companyCode = [...res.data.data];
        });
      },
      search() {
        if (!this.queryParams.queryDate) {
          this.$message.error('请选择查询日期');
          return;
        }
        if (!this.queryParams.cusid) {
          this.$message.error('请选择查询客户');
          return;
        }
        const params = {
          batchIds: this.queryParams.batchId,
          cusId: this.queryParams.cusid,
          date: this.queryParams.queryDate
        };
        list(params).then(res => {
          const tableData = [...res.data.data.data];
          this.tableData = tableData
        });

      },
      download() {
        const params = {
          date: this.queryParams.queryDate ? this.queryParams.queryDate : 'default',
          cusId: this.queryParams.cusid ? this.queryParams.cusid : 'all'
        };
        down(params).then(res => {
          this.$downloadFile(res);
        });
      },
      downloadSource() {
        let cusid = this.queryParams.cusid || 'all';
        window.open(`https://hrms.ciicpt.com.cn/api/bizwage/bspsalary/getTeslaSalaryDetail?cusId=${cusid}`, '_blank');
      },
      sendEmail() {

      }
    },
    created() {
      this.init();
    }
  };
</script>

<style scoped>
  .container {
    padding: 20px;
    font-family: Arial, sans-serif;
  }

  .toolbar {
    margin-bottom: 20px;
  }

  .btn {
    margin-right: 10px;
  }

  .search-form {
    display: flex;
    flex-wrap: wrap;
    margin-bottom: 20px;
  }

  .search-form label,
  .search-form input,
  .search-form button {
    margin-right: 10px;
    margin-bottom: 10px;
  }

  .data-table table {
    width: 100%;
    border-collapse: collapse;
  }

  .data-table th,
  .data-table td {
    padding: 8px;
    text-align: left;
    border-bottom: 1px solid #ddd;
  }

  .data-table th {
    background-color: #f2f2f2;
    font-weight: bold;
  }

  .data-table .odd-row {
    background-color: #f9f9f9;
  }
</style>
